import { render, staticRenderFns } from "./create-business-profile.vue?vue&type=template&id=d9827fc6&scoped=true"
import script from "./create-business-profile.vue?vue&type=script&lang=js"
export * from "./create-business-profile.vue?vue&type=script&lang=js"
import style0 from "./create-business-profile.vue?vue&type=style&index=0&id=d9827fc6&prod&lang=css&scoped=true"
import style1 from "./create-business-profile.vue?vue&type=style&index=1&id=d9827fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9827fc6",
  null
  
)

export default component.exports